module.exports = __webpack_public_path__ + "img/qdap-product-card-tag.65624c2.svg";